/**
 * admin-ops-api の `/api/v1/conversion`（商談なし有料化率）client。#1716 SS-14。
 * `trials-api.ts` と同じ fetch ラッパの形。
 */

/** 相談の有無。`unconfirmed` = Founder がまだ確定していない（分母から外す）。 */
export type ConsultStatus = 'consulted' | 'no_consult' | 'unconfirmed';

export interface ConversionBucket {
  paid: number;
  noConsult: number;
  consulted: number;
  unconfirmed: number;
  /** 相談なし ÷（相談なし + 相談あり）。確認済みが 0 件なら null。 */
  rate: number | null;
}

export interface ConversionWeek extends ConversionBucket {
  /** 週の月曜（JST、YYYY-MM-DD）。 */
  weekStart: string;
}

export interface ConversionRow {
  workspaceId: string;
  displayName: string;
  paidAt: string;
  status: ConsultStatus;
  note: string | null;
  /** 相談の候補（一致したドメイン・件数・最新の日だけ。メールアドレスは含まない）。 */
  candidate: { domain: string; count: number; latestAt: string } | null;
}

export type ConversionResult =
  | { configured: false }
  | {
      configured: true;
      weeks: ConversionWeek[];
      cumulative: ConversionBucket;
      rows: ConversionRow[];
    };

function base(baseUrl: string): string {
  return `${baseUrl.replace(/\/$/, '')}/api/v1/conversion`;
}

export async function fetchConversion(baseUrl: string): Promise<ConversionResult> {
  const res = await fetch(base(baseUrl), {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error(`admin-ops API /conversion failed: ${res.status}`);
  return (await res.json()) as ConversionResult;
}

/** 相談の有無を確定する（`unconfirmed` なら未確認に戻す）。 */
export async function setConsultStatus(
  baseUrl: string,
  workspaceId: string,
  status: ConsultStatus,
): Promise<void> {
  const url = `${base(baseUrl)}/${workspaceId}/consult`;
  const res =
    status === 'unconfirmed'
      ? await fetch(url, {
          method: 'DELETE',
          credentials: 'include',
          headers: { Accept: 'application/json' },
        })
      : await fetch(url, {
          method: 'PUT',
          credentials: 'include',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ status }),
        });
  if (!res.ok) throw new Error(`admin-ops API /conversion consult failed: ${res.status}`);
}
